import { Mixins } from 'vue-property-decorator'
import { Mixin } from 'vue-mixin-decorator'
import { hasBklrModule } from '@/views/Project/Bklr/plugins/bklr'
import MixinInterface from '@/_mixins/index'

@Mixin
export default class MenuMixin extends Mixins<MixinInterface>() {
    get $$project() {
        return this.view == 'project' && this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    // NOTE: if menu item links to a module, make sure the key is the same as the module id
    // support https://app.clickup.com/t/865ck5a4f
    get $$projectMenu() {
        return {
            dashboard: {
                title: this.$t('project_menu.dashboard'),
                icon: 'fas fa-home',
                to: { name: 'project-dashboard' },
                visible: this.hasAnyPermissions(this.allPermissions),
                isDisabled: false,
            },
            notifications: {
                title: this.$t('project_menu.notifications'),
                icon: 'fas fa-bell',
                to: { name: 'notifications' },
                visible: this.hasAnyPermissions(this.allPermissions),
                isDisabled: false,
            },
            psi: {
                title: this.$t('project_menu.psi'),
                icon: 'fas fa-books',
                to: { name: 'psi' },
                //     to: { name: 'psi-index' },
                visible: this.isModuleAccessible('psi'),
                isDisabled:
                    this.isModuleArchived('psi') ||
                    this.isModuleClosed('psi') ||
                    this.isModuleDeleted('psi'),
                deletedAt: this.isModuleDeletionAt('psi'),
            },
            course: {
                title: this.$t('project_menu.course'),
                icon: 'fas fa-file-certificate',
                to: { name: 'course' },
                visible:
                    this.isModuleAccessible('course') &&
                    this.hasPermission(this.allPermissions, 'course.'),
                isDisabled:
                    this.isModuleArchived('course') ||
                    this.isModuleClosed('course') ||
                    this.isModuleDeleted('course'),
                deletedAt: this.isModuleDeletionAt('course'),
            },
            hse: {
                title: this.$t('project_menu.hse'),
                icon: 'fas fa-traffic-cone',
                to: { name: 'hse-all' },
                visible: this.isModuleAccessible('hse'),
                isDisabled:
                    this.isModuleArchived('hse') ||
                    this.isModuleClosed('hse') ||
                    this.isModuleDeleted('hse'),
                deletedAt: this.isModuleDeletionAt('hse'),
            },
            observation: {
                title: this.$t('project_menu.observation'),
                icon: 'fas fa-exclamation-circle',
                to: { name: 'observations' },
                visible: this.isModuleAccessible('observation'),
                isDisabled:
                    this.isModuleArchived('observation') ||
                    this.isModuleClosed('observation') ||
                    this.isModuleDeleted('observation'),
                deletedAt: this.isModuleDeletionAt('observation'),
            },
            contractor: {
                title: this.$t('project_menu.contractors'),
                icon: 'fas fa-sitemap',
                to: { name: this.currentGroup ? 'group-contractors' : 'project-contractors' },
                visible:
                    this.isModuleAccessible('contractor') &&
                    this.hasPermission(this.allPermissions, 'contractor.'),
                isDisabled:
                    this.isModuleArchived('contractor') ||
                    this.isModuleClosed('contractor') ||
                    this.isModuleDeleted('contractor'),
                deletedAt: this.isModuleDeletionAt('contractor'),
            },
            itbase: {
                title: this.$t('project_menu.ITBASE'),
                icon: 'fas fa-folder',
                href: this.currentProject ? this.currentProject.attributes.itbaseUrl : '',
                target: '_blank',
                visible:
                    this.currentProject &&
                    this.currentProject.attributes.itbaseUrl &&
                    this.isModuleAccessible('document'),
                isDisabled:
                    this.isModuleArchived('document') ||
                    this.isModuleClosed('document') ||
                    this.isModuleDeleted('document'),
                deletedAt: this.isModuleDeletionAt('document'),
            },
            // task: {
            //     title: this.$t('project_menu.task'),
            //     icon: 'fas fa-tasks',
            //     to: {name: 'tasks' },
            //     visible: this.isModuleAccessible('task')
            // },
            users: {
                title: this.$t('project_menu.people'),
                icon: 'fas fa-users',
                to: { name: 'users' },
                visible: this.hasAnyPermissions(this.allPermissions),
                isDisabled: false,
            },
            bkl: {
                title: this.$t('project_menu.bklr'),
                icon: 'fas fa-address-card',
                to: { name: 'bklr' },
                visible: hasBklrModule(this.$$project) && this.isModulePresent('personnel'),
                isDisabled:
                    this.isModuleArchived('personnel') ||
                    this.isModuleClosed('personnel') ||
                    this.isModuleDeleted('personnel'),
                deletedAt: this.isModuleDeletionAt('personnel'),
            },
            access: {
                title: this.$t('project_menu.access_control'),
                icon: 'fas fa-shield-check',
                to: { name: 'access-control' },
                visible: this.isModulePresent('access'),
                isDisabled:
                    this.isModuleArchived('access') ||
                    this.isModuleClosed('access') ||
                    this.isModuleDeleted('access'),
                deletedAt: this.isModuleDeletionAt('access'),
            },
            personnel: {
                title: this.$t('project_menu.personnel'),
                icon: 'fas fa-train',
                to: { name: 'personnel' },
                visible: this.showTagInterface && this.isModuleAccessible('personnel'),
                isDisabled:
                    this.isModuleArchived('personnel') ||
                    this.isModuleClosed('personnel') ||
                    this.isModuleDeleted('personnel'),
                deletedAt: this.isModuleDeletionAt('personnel'),
            },
            settings: {
                title: this.$t('project_menu.settings'),
                icon: 'fas fa-cog',
                to: { name: 'settings' },
                visible:
                    this.hasPermission(this.allPermissions, 'manage') ||
                    this.hasPermission(this.allPermissions, 'admin') ||
                    this.hasPermission(this.allPermissions, 'delegate_access'),
                isDisabled: false,
            },
        }
    }
}
